import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NotificationService } from '@rentigo/ngx-common';
import { Config } from './config.model';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private config?: Config;

  constructor(private http: HttpClient, private notificationService: NotificationService) { }

  loadConfig(): Observable<Config> {
    return this.http
      .get<Config>('./assets/config/config.json')
      .pipe(
        tap(config => this.config = config),
        catchError(error => {
          this.notificationService.error('Failed to load application configuration');
          throw error;
        })
      );
  }

  getConfig() {
    return this.config;
  }
}
